export default __webpack_public_path__ + "images/LITOR.002fd84.png";